module.exports = __webpack_public_path__ + "img/06.e0ddd298.png";